module.exports = __webpack_public_path__ + "static/media/mx.434d6364.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mx.svg
// module id = 897
// module chunks = 0